import React, { useEffect, useRef, MouseEvent } from 'react';
import styles from './styles/MobileRenewPopup.module.scss';
import { Triangle, X } from 'react-feather';
import ReactDOM from 'react-dom';
import classnames from 'classnames'; // Ensure classnames is imported

interface MobileRenewPopupProps {
  show: boolean;
  setShow: (show: boolean) => void;
  allowMarketScan: boolean;
}

const MobileRenewPopup: React.FC<MobileRenewPopupProps> = ({
  show,
  setShow,
  allowMarketScan,
}) => {
  const popupRef = useRef<HTMLDivElement>(null);

  const onClose = () => {
    setShow(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []); // No need to add onClose here, since it's stable and does not depend on any props or state

  if (!show) return null;

  return ReactDOM.createPortal(
    <div className={styles.container} ref={popupRef}>
      <div className={styles.header}>
        <X className={styles.close} color="white" onClick={onClose} />
        <p>Renew your expired policy</p>
        <p>- Upload or enter renewal</p>
      </div>
      <div className={styles.content}>
        <p>
          Keep your information up-to-date! Your renewal PDF should have been
          emailed to you by your insurer.
        </p>
        <p>
          Tap to upload your new renewal documents or alternatively you can
          enter your renewal information manually.
        </p>
      </div>
      <Triangle
        className={classnames(
          styles.triangleLeft,
          !allowMarketScan && styles.triangleLeftNoMS,
        )}
      />
      <Triangle
        className={classnames(
          styles.triangleRight,
          !allowMarketScan && styles.triangleRightNoMS,
        )}
      />
    </div>,
    document.getElementById('layout-container')!,
  );
};

export default MobileRenewPopup;
